/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * NowControllerV4Api - axios parameter creator
 */
export const NowControllerV4ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckMerchantsPost: (tenant_1, language_1, BasicCheckObject_1, ...args_1) => __awaiter(this, [tenant_1, language_1, BasicCheckObject_1, ...args_1], void 0, function* (tenant, language, BasicCheckObject, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV4TenantLanguageBasicCheckMerchantsPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('nowV4TenantLanguageBasicCheckMerchantsPost', 'language', language);
            const localVarPath = `/now/v4/{tenant}/{language}/basicCheck/merchants`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(BasicCheckObject, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckPost: (tenant_1, language_1, BasicCheckObject_1, ...args_1) => __awaiter(this, [tenant_1, language_1, BasicCheckObject_1, ...args_1], void 0, function* (tenant, language, BasicCheckObject, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV4TenantLanguageBasicCheckPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('nowV4TenantLanguageBasicCheckPost', 'language', language);
            const localVarPath = `/now/v4/{tenant}/{language}/basicCheck`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(BasicCheckObject, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckProductsPost: (tenant_1, language_1, BasicCheckObject_1, ...args_1) => __awaiter(this, [tenant_1, language_1, BasicCheckObject_1, ...args_1], void 0, function* (tenant, language, BasicCheckObject, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV4TenantLanguageBasicCheckProductsPost', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('nowV4TenantLanguageBasicCheckProductsPost', 'language', language);
            const localVarPath = `/now/v4/{tenant}/{language}/basicCheck/products`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(BasicCheckObject, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Wraps now merchant center services
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} sellerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageNowMerchantSellerIdGet: (tenant_1, language_1, sellerId_1, ...args_1) => __awaiter(this, [tenant_1, language_1, sellerId_1, ...args_1], void 0, function* (tenant, language, sellerId, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV4TenantLanguageNowMerchantSellerIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('nowV4TenantLanguageNowMerchantSellerIdGet', 'language', language);
            // verify required parameter 'sellerId' is not null or undefined
            assertParamExists('nowV4TenantLanguageNowMerchantSellerIdGet', 'sellerId', sellerId);
            const localVarPath = `/now/v4/{tenant}/{language}/nowMerchant/{sellerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get Now related invoices and other documents
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} orderNumber
         * @param {string} subOrderId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet: (tenant_1, language_1, orderNumber_1, subOrderId_1, documentId_1, ...args_1) => __awaiter(this, [tenant_1, language_1, orderNumber_1, subOrderId_1, documentId_1, ...args_1], void 0, function* (tenant, language, orderNumber, subOrderId, documentId, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'language', language);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'orderNumber', orderNumber);
            // verify required parameter 'subOrderId' is not null or undefined
            assertParamExists('nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'subOrderId', subOrderId);
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet', 'documentId', documentId);
            const localVarPath = `/now/v4/{tenant}/{language}/orders/{orderNumber}/{subOrderId}/documents/{documentId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)))
                .replace(`{${"subOrderId"}}`, encodeURIComponent(String(subOrderId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NowControllerV4Api - functional programming interface
 */
export const NowControllerV4ApiFp = function (configuration) {
    const localVarAxiosParamCreator = NowControllerV4ApiAxiosParamCreator(configuration);
    return {
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckMerchantsPost(tenant, language, BasicCheckObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV4TenantLanguageBasicCheckMerchantsPost(tenant, language, BasicCheckObject, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NowControllerV4Api.nowV4TenantLanguageBasicCheckMerchantsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckPost(tenant, language, BasicCheckObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV4TenantLanguageBasicCheckPost(tenant, language, BasicCheckObject, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NowControllerV4Api.nowV4TenantLanguageBasicCheckPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {BasicCheckObject} [BasicCheckObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckProductsPost(tenant, language, BasicCheckObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV4TenantLanguageBasicCheckProductsPost(tenant, language, BasicCheckObject, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NowControllerV4Api.nowV4TenantLanguageBasicCheckProductsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Wraps now merchant center services
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} sellerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageNowMerchantSellerIdGet(tenant, language, sellerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV4TenantLanguageNowMerchantSellerIdGet(tenant, language, sellerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NowControllerV4Api.nowV4TenantLanguageNowMerchantSellerIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get Now related invoices and other documents
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} orderNumber
         * @param {string} subOrderId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(tenant, language, orderNumber, subOrderId, documentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(tenant, language, orderNumber, subOrderId, documentId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NowControllerV4Api.nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * NowControllerV4Api - factory interface
 */
export const NowControllerV4ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NowControllerV4ApiFp(configuration);
    return {
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {NowControllerV4ApiNowV4TenantLanguageBasicCheckMerchantsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckMerchantsPost(requestParameters, options) {
            return localVarFp.nowV4TenantLanguageBasicCheckMerchantsPost(requestParameters.tenant, requestParameters.language, requestParameters.BasicCheckObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {NowControllerV4ApiNowV4TenantLanguageBasicCheckPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckPost(requestParameters, options) {
            return localVarFp.nowV4TenantLanguageBasicCheckPost(requestParameters.tenant, requestParameters.language, requestParameters.BasicCheckObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
         * @param {NowControllerV4ApiNowV4TenantLanguageBasicCheckProductsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageBasicCheckProductsPost(requestParameters, options) {
            return localVarFp.nowV4TenantLanguageBasicCheckProductsPost(requestParameters.tenant, requestParameters.language, requestParameters.BasicCheckObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Wraps now merchant center services
         * @param {NowControllerV4ApiNowV4TenantLanguageNowMerchantSellerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageNowMerchantSellerIdGet(requestParameters, options) {
            return localVarFp.nowV4TenantLanguageNowMerchantSellerIdGet(requestParameters.tenant, requestParameters.language, requestParameters.sellerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Now related invoices and other documents
         * @param {NowControllerV4ApiNowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(requestParameters, options) {
            return localVarFp.nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(requestParameters.tenant, requestParameters.language, requestParameters.orderNumber, requestParameters.subOrderId, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NowControllerV4Api - object-oriented interface
 */
export class NowControllerV4Api extends BaseAPI {
    /**
     * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
     * @param {NowControllerV4ApiNowV4TenantLanguageBasicCheckMerchantsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV4TenantLanguageBasicCheckMerchantsPost(requestParameters, options) {
        return NowControllerV4ApiFp(this.configuration).nowV4TenantLanguageBasicCheckMerchantsPost(requestParameters.tenant, requestParameters.language, requestParameters.BasicCheckObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
     * @param {NowControllerV4ApiNowV4TenantLanguageBasicCheckPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV4TenantLanguageBasicCheckPost(requestParameters, options) {
        return NowControllerV4ApiFp(this.configuration).nowV4TenantLanguageBasicCheckPost(requestParameters.tenant, requestParameters.language, requestParameters.BasicCheckObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Execute a basic NOW eligibility check for a given zip code / product(s) / cart.
     * @param {NowControllerV4ApiNowV4TenantLanguageBasicCheckProductsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV4TenantLanguageBasicCheckProductsPost(requestParameters, options) {
        return NowControllerV4ApiFp(this.configuration).nowV4TenantLanguageBasicCheckProductsPost(requestParameters.tenant, requestParameters.language, requestParameters.BasicCheckObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Wraps now merchant center services
     * @param {NowControllerV4ApiNowV4TenantLanguageNowMerchantSellerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV4TenantLanguageNowMerchantSellerIdGet(requestParameters, options) {
        return NowControllerV4ApiFp(this.configuration).nowV4TenantLanguageNowMerchantSellerIdGet(requestParameters.tenant, requestParameters.language, requestParameters.sellerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get Now related invoices and other documents
     * @param {NowControllerV4ApiNowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(requestParameters, options) {
        return NowControllerV4ApiFp(this.configuration).nowV4TenantLanguageOrdersOrderNumberSubOrderIdDocumentsDocumentIdGet(requestParameters.tenant, requestParameters.language, requestParameters.orderNumber, requestParameters.subOrderId, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }
}
